import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { type Note } from "../../../../models/note.ts";
import { type ColumnDef } from "../../dui/data-table/dui-data-table.ts";
import { type Slug } from "../../../../models/slug.ts";
import * as Styles from "../../../styles.ts";
import { customEvent } from "../../../util/event.ts";

export const editNoteEvent = customEvent<{ slug: string; projectId: string }>(
  "edit-note",
  { bubbles: true, composed: true },
);

// Components
import "../../dui/data-table/dui-data-table.ts";

const styles = css`
  :host {
    display: block;
    height: 100cqh;
    width: 100cqw;
    container-type: size;
  }
`;

const columns: ColumnDef<Note>[] = [
  {
    key: "title",
    header: "Title",
    sortable: true,
    headerStyle: { width: "90%" },
  },
  {
    key: "confidence",
    header: "Confidence",
    sortable: true,
    cell: (row) => `${Math.round(row.confidence * 100)}%`,
    headerStyle: { width: "10%" },
  },
];

@customElement("scan-hits-panel")
export class ScanHitsPanel extends LitElement {
  static override styles = [Styles.base, styles];

  @property()
  accessor scanHits: Map<Slug, Note> = new Map();

  @property({ type: String })
  accessor projectId: string | undefined = undefined;

  #onRowClick = (event: CustomEvent<{ row: Note }>): void => {
    const { row } = event.detail;
    if (row.slug === undefined || this.projectId === undefined) return;
    this.dispatchEvent(
      editNoteEvent({ slug: row.slug, projectId: this.projectId }),
    );
  };

  override render() {
    const rows = Array.from(this.scanHits.values());

    return html`
      <dui-data-table
        .columns="${columns}"
        .data="${rows}"
        @row-click="${this.#onRowClick}"
        page-size="15"
      ></dui-data-table>
    `;
  }
}
